// Rassicurazioni rimosse su richiesta. Componente mantenuto per compatibilità.
export function TrustBand() {
  return null;
}

export function TrustBadge() {
  return null;
}
